import React from "react";
import './Home.css';
import HomeSearchbar from "../Components/HomeSearchbar";
import HomeLeft from "../Components/HomeLeft";
import HomeBanner from "../Components/HomeBanner";
import SearchCarsSection from "../Components/SearchCarsSection";
import NewArrivals from "../Components/NewArrivals";
import DemandedArrivals from "../Components/DemandedArrivals";
import SellingDiscount from "../Components/SellingDiscount";
import HomeRight from "../Components/HomeRight";
import ReviewCarousel from "../Components/ReviewCarousel";
import AnimateGlobe from "../Components/AnimateGlobe";


const Home = () => {
    return (
        <>
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    {/* <HomeSearchbar /> */}
                    <HomeBanner />
                    <SearchCarsSection />
                </div>
            </div>
        </div>
        <div className="container-fluid">
            <div className="row">
                {/* <div className="col-2 leftcol">
                    <HomeLeft />
                </div> */}
                <div className="col-12 wow fadeInUp">
                    <NewArrivals />
                    <DemandedArrivals />
                </div>
                {/* <div className="col-2 rightcol">
                    <HomeRight />
                </div> */}
            </div>
        </div>
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="carousel-bg">
                        <h2 className="carousel-heading">WHY CHOOSE M.I TRADING JAPAN</h2>
                        <p>We offer a wide range of cars available at our sales center including Japan, Thailand, Burma .</p>
                    </div>
                    <AnimateGlobe />
                    <SellingDiscount />
                </div>
            </div>
        </div>
        <div className="container-fluid wow fadeInUp" data-wow-delay="0.4s">
            <div className="row">
                <div className="col-12">
                     
                    <ReviewCarousel />
                </div>
            </div>
        </div>
        </>
    );
};

export default Home;